import { useTranslation } from 'react-i18next'

import { UmbrellaRoute } from '../../../../../enums/UmbrellaRoute'
import { UmbrellaSettingsTabItem } from '../types/umbrellaSettingsTabItem'
import { UseUmbrellaSettingsTabItems } from '../types/useUmbrellaSettingsTabItems'

export const useUmbrellaUserSettingsTabItems = (): UseUmbrellaSettingsTabItems => {
  const { t } = useTranslation()

  const items: UmbrellaSettingsTabItem[] = [
    {
      route: UmbrellaRoute.SettingsProfile,
      text: t('settings.user.profile'),
    },
    {
      route: UmbrellaRoute.SettingsNotifications,
      text: t('settings.user.notifications'),
    },
    {
      route: UmbrellaRoute.SettingsPrivacy,
      text: t('settings.user.privacy'),
    },
  ]

  return { items }
}
